export default "https://cdn-static.gokick.com/assets/c736ccdc0086f37925b8733f1854c980393ad61e/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";